import { RequestActionTypes } from "./createRequestActionTypes";

export type NoFetchActionAdditionalData = undefined

export interface StartFetchingAction<T = NoFetchActionAdditionalData> {
    type: string
    additionalData?: T
}

export interface SuccessFetchingAction<T, P = NoFetchActionAdditionalData> {
    type: string
    result: T
    additionalData?: P
}

export interface FetchErrorInfo<T = any> {
    message: string
    errorObject: T
}
export interface ErrorFetchingAction<P = NoFetchActionAdditionalData> {
    type: string
    error: FetchErrorInfo
    additionalData?: P
}

export type FetchRequestActions<TResult, TParameters = NoFetchActionAdditionalData> =
    StartFetchingAction<TParameters>
    | SuccessFetchingAction<TResult, TParameters>
    | ErrorFetchingAction<TParameters>

export const createRequestActions = <TResult, TParameters = NoFetchActionAdditionalData>(actionTypes: RequestActionTypes, additionalData?: TParameters) => ({
    start: (): StartFetchingAction<TParameters> => ({ type: actionTypes.start, additionalData }),
    startWithoutSnackbar: (): StartFetchingAction<TParameters> => ({ type: actionTypes.startWithoutSnackbar, additionalData }),
    success: (result: TResult): SuccessFetchingAction<TResult, TParameters> => ({
        type: actionTypes.success,
        result,
        additionalData
    }),
    successWithoutSnackbar: (result: TResult): SuccessFetchingAction<TResult, TParameters> => ({
        type: actionTypes.successWithoutSnackbar,
        result,
        additionalData
    }),
    error: (message: string, errorObject: any): ErrorFetchingAction<TParameters> => ({
        type: actionTypes.error,
        error: {
            message,
            errorObject
        },
        additionalData
    })
})